// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"165":"7b1fda68","283":"49c46820"}[chunkId] + ".css";
};